import GetIntegrationCallsRequestModelBase from '../_generated/modelBases/get-integration-calls-request-model-base';

export default class GetIntegrationCallsRequestModel extends GetIntegrationCallsRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
